import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminResponseDto } from 'src/app/front-user/shipyard-service/models/adminResponseDto';
import { RegisterationAdminDecision, Languages, Service, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { RegisterComponent } from 'src/app/front-user/common-features/registration/register.component';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';

@Component({
  selector: 'app-registration-admin-decision',
  templateUrl: './registration-admin-decision.component.html',
  styleUrls: ['./registration-admin-decision.component.css']
})
export class RegistrationAdminDecisionComponent implements OnInit {
  registerAdminForm: FormGroup;
  decision = RegisterationAdminDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  baseRequestId: string = '';
  decisionValue: number;
  submitted = false;
  loading = false;
  adminDecisionObject: RegistrationAdminDto = new RegistrationAdminDto();
  isReadOnly = true;
  shippingExpirationDate: Date;
  taxCardExpirationDate: Date;
  taxCardAppendixExpirationDate: Date;
  taxAuthorizationExpirationDate: Date;
  commercialRecordExpirationDate: Date;
  otherDocumentsExpirationDate: Date;
  agentId: string;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @ViewChild('registerRequest',{static: false}) registerRequest: RegisterComponent;
  error: any = { isError: false, errorMessage: '' };
  user: User = new User();
  baseRequestDTO: BaseRequest;
  showRequest = false;
  isErrorMessage: boolean = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService,
    private adminSrv: RegistrationAdminService, private translate: TranslateService,
    private baseRequestService: BaseRequestService, private agentService: AgentService, ) {

    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  getBaseRequest() {
    this.baseRequestService.getByRequestorId(this.baseRequestId, Service.AgentRegisteration).subscribe(
      d => {
        this.baseRequestDTO = d.Data;

        this.agentId = this.baseRequestDTO.RequestorId;
        if (history.state.data && history.state.data.isCompleted) {
          this.getAgent(this.agentId);
        }
      }
    )
  }

  buildForm(decision) {
    this.registerAdminForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RegisterationAdminDecision.Approve) {
      this.registerAdminForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MainTreasuryNumber: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern(this.numberRegex)]],
      });

    }
    if (decision == RegisterationAdminDecision.MoreInformation) {
      this.registerAdminForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      });

    }
  }

  public getAgent(agentId: string) {
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          if (resObj.Data['MoreInformation'] && !resObj.Data['MainTreasuryNumber']) {
            this.decisionValue = RegisterationAdminDecision.MoreInformation;
            this.buildForm(this.decisionValue);
            this.registerAdminForm.patchValue({
              Decision: RegisterationAdminDecision.MoreInformation,
              MoreInformation: resObj.Data['MoreInformation']
            });
          }
          else {
            this.decisionValue = RegisterationAdminDecision.Approve;
            this.buildForm(this.decisionValue);
            this.registerAdminForm.patchValue({
              Decision: RegisterationAdminDecision.Approve,
              MainTreasuryNumber: resObj.Data['MainTreasuryNumber']
            });
          }

        }
        this.formMode = FormMode.Readonly;
        this.registerAdminForm.disable();
      });

  }

  changeDecision(value) {
    this.buildForm(value);
    this.registerAdminForm.patchValue({
      Decision: value
    });

    this.decisionValue = value;
    if (this.decisionValue == RegisterationAdminDecision.MoreInformation) {
      this.isReadOnly = false;
    } else {
      this.isReadOnly = true;
    }
  }

  get f() {
    return this.registerAdminForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.registerAdminForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject = this.registerAdminForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxAuthorizationExpirationDate) {
      this.adminDecisionObject.taxAuthorizationExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxAuthorizationExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxAuthorizationId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxAuthorizationId;

    }
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardAppendixExpirationDate) {
      this.adminDecisionObject.taxCardAppendixExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardAppendixExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxCardAppendixId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardAppendixId;

    }
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardExpirationDate) {
      this.adminDecisionObject.taxCardExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.taxCardId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.taxCardId;

    }
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.shippingExpirationDate) {
      this.adminDecisionObject.shippingExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.shippingExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.shippingId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.licensingsShippingId;

    }
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.otherDocumentsExpirationDate) {
      this.adminDecisionObject.otherDocumentsExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.otherDocumentsExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.otherDocumentsId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.otherDocumentsId;

    }
    if (this.registerRequest.registerForm.controls.agent.value.agentCertificate.commercialRecordExpirationDate) {
      this.adminDecisionObject.commercialRecordExpirationDate = this.registerRequest.registerForm.controls.agent.value.agentCertificate.commercialRecordExpirationDate.toLocaleString('en-US');
      this.adminDecisionObject.commercialRecordId = this.registerRequest.registerForm.controls.agent.value.agentCertificate.commercialRecordId;


    }

    this.adminSrv.addAdminDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.registerAdminForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.lockTaskErrorMessage = false;
            this.isErrorMessage = false;
            // this.router.navigate(['/Tasks']);
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
            this.loading = false;
          }

        });
  }

}
